import type { Router } from '@angular/router';
import { v7 } from 'uuid';
import type { RouteInfos } from '@camino-solutions/core/router';

/**
 * Generates route path for page flow by flow ID.
 * @param flow - The flow identifier (e.g., 'company', 'document')
 * @returns Route path string
 */
export function pageFlowFlowIdRoutePathGenerator(flow: string) {
  return `/page-flow/${flow}`;
}

/**
 * Generates base page-flow route path.
 * @returns Route path string
 */
export function pageFlowTokenRoutePathGenerator() {
  return `/page-flow`;
}

/**
 * Generates route path for page flow initiated from a card.
 * @returns Route path string
 */
export function pageFlowFromCardRoutePathGenerator() {
  return `/page-flow/from-card`;
}

/**
 * Navigates to page flow by flow ID.
 * Generates a fake token using UUID v7 for the route info.
 *
 * @param flowId - The flow identifier to navigate to
 * @param router - Angular Router instance
 * @param queryParams - Optional query parameters to pass to the flow (e.g., { companyId: 'abc-123' })
 * @param returnUrl - Optional URL to navigate to after flow completion
 */
export function pageFlowGoToByFlowId(
  flowId: string,
  router: Router,
  queryParams?: Record<string, string>,
  returnUrl?: string,
) {
  const info: RouteInfos = {
    fakeToken: { type: 'string', value: v7() },
  };
  if (returnUrl) {
    info['returnUrl'] = { type: 'string', value: returnUrl };
  }
  void router.navigate([pageFlowFlowIdRoutePathGenerator(flowId)], {
    info,
    queryParams,
  });
}
